import {
  HeadingText,
  StackLayout,
  HtmlToReact,
  SkeletonText,
} from '@leagueplatform/genesis-core';
import { usePolicyDetailsInformation } from 'hooks/use-get-wallet-details.hook';
import { useProductSegmentation } from 'hooks/use-product-segmentation.hook';

export function PolicyDetails() {
  const { title, description, isLoading } = usePolicyDetailsInformation();
  const { productSubTypes } = useProductSegmentation();
  const hasPolicyDetails =
    productSubTypes.includes('pdp') || productSubTypes.includes('dvh');

  if (!hasPolicyDetails) return null;

  if (isLoading) {
    return (
      <StackLayout
        spacing="$oneAndHalf"
        css={{
          width: '100%',
        }}
      >
        <SkeletonText header width={258} />
        <SkeletonText lines={3} />
      </StackLayout>
    );
  }

  return (
    <StackLayout
      css={{
        marginY: '$half',
        maxWidth: '784px',
      }}
      spacing="$half"
    >
      <HeadingText level="2" size="md" css={{ marginBottom: '$half' }}>
        {title}
      </HeadingText>
      <HtmlToReact htmlString={description} />
    </StackLayout>
  );
}
